import {appHelper} from "../utils/helpers/appHelper.js";
import {geoKey} from "../utils/geoKey.js";
import axios from 'axios';
import {connectionHelper} from "../utils/helpers/connectionHelper.js";

export const ajaxMultipart = axios.create({
    baseURL: appHelper.url.root(),
    timeout: 3600000,
    withCredentials : true
});

const SLOW_CONNECTION_THRESHOLD = 10000; // 1 second

ajaxMultipart.interceptors.request.use(
    (config) => {

        config.headers['Access-Control-Allow-Credentials'] = true;
        if (config.url === "/sanctum/csrf-cookie") {
            config.headers['Content-Type'] = 'application/json';
            config.baseURL = appHelper.url.auth(true);
        } else {
            config.headers['Content-Type'] = 'multipart/form-data';
            config.headers['app-gid'] = geoKey.getIKey();
        }

        config.metadata = { startTime: new Date() };

        connectionHelper.onLine();
        return config;
    },
    (error) => {
        connectionHelper.onLine();
        return Promise.reject(error);
    }
);

// Add a response interceptor
ajaxMultipart.interceptors.response.use( (response) => {
        const duration = new Date() - response.config.metadata.startTime; // Calculate duration
        if (duration > SLOW_CONNECTION_THRESHOLD) {
            connectionHelper.bsToast.show(`Slow connection detected: ${duration} ms`);
        }
        return response;
    },  (error) => {
        connectionHelper.onLine();
        if(error.response) {
            error.response.isCancel = !!(axios.isCancel(error) || error.message.includes('BS_BINDING_ABORTED') || error.name === 'AbortError' || error.code === 'ECONNABORTED' || error.message === 'BS_BINDING_ABORTED');
        }
        return Promise.reject(error);
    }
);
